type ToastApi = {
  success: (content: string) => void;
  error: (content: string) => void;
  warning: (content: string) => void;
  info: (content: string) => void;
};

let toastApi: ToastApi | null = null;

export function setToastApi(api: ToastApi) {
  toastApi = api;
}

function show(type: keyof ToastApi, content: string) {
  if (toastApi) {
    toastApi[type](content);
    return;
  }

  window.dispatchEvent(
    new CustomEvent("app-toast", {
      detail: { type, content },
    })
  );
}

export const toast = {
  success: (content: string) => show("success", content),
  error: (content: string) => show("error", content),
  warning: (content: string) => show("warning", content),
  info: (content: string) => show("info", content),
};
